import { AFS_Raw_Export } from './afs_raw_export'

// CHANGE THESE VALUES IF NECESSARY TO MATCH THE EXPORTED FILE
const FILTER_KEY = 'Filter L1'
const TYPE_MAP = {
  brand: 'AFS Brands',
  category: 'AFS Categories',
  lifestyle: 'AFS Lifestyle',
  liveramp: 'AFS LiveRamp',
}
const LABEL_KEY = 'Filter Display value'
const VALUE_KEY = 'Actual value'
const SCORES = ['High', 'Medium', 'Low']
// const SCORE_REPLACE = ' - High'

const format = (item) => ({ label: item[LABEL_KEY], name: item[VALUE_KEY], check: null })

const sorted = JSON.parse(JSON.stringify(AFS_Raw_Export)).toSorted((a, b) =>
  a[LABEL_KEY].localeCompare(b[LABEL_KEY])
)

const allScores = sorted.flatMap((item) =>
  SCORES.map((score) => ({
    ...item,
    [LABEL_KEY]: `${item[LABEL_KEY]} - ${score} Propensity`,
    [VALUE_KEY]: `${item[VALUE_KEY]} - ${score}`,
  }))
)

const AFSBrands = allScores.filter((item) => item[FILTER_KEY] === TYPE_MAP.brand).map(format)
const AFSCategories = allScores.filter((item) => item[FILTER_KEY] === TYPE_MAP.category).map(format)
const AFSLifestyles = allScores
  .filter((item) => item[FILTER_KEY] === TYPE_MAP.lifestyle)
  .map(format)
const AFSLiveramp = allScores.filter((item) => item[FILTER_KEY] === TYPE_MAP.liveramp).map(format)

// debug function to find duplicate items in a list when updating the data.
// keep it here.
// const findDuplicate = (list) => {
//   const MAP = {}
//   list.forEach((item) => {
//     MAP[item.name] = 1 || MAP[item.name] + 1
//   })
//   return Object.keys(MAP).filter((key) => MAP[key] > 1)
// }

export { AFSBrands, AFSCategories, AFSLifestyles, AFSLiveramp }
